<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="relative">

    <!-- Estado vazio (sem templates e sem busca) -->
    <ng-container *ngIf="templates.length === 0 && !searchTerm">
        <app-no-template-list [searchTerm]='searchTerm' [showHeader]="false"></app-no-template-list>
    </ng-container>

    <!-- Com dados ou buscando -->
    <ng-container *ngIf="templates.length > 0 || searchTerm">

        <!-- TABELA DESKTOP -->
        <div class="hidden md:block overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500 mb-8">
                <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
                    <tr class="text-left">
                        <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeOrdernation('name')">
                            Nome
                            <fa-icon [icon]="orderBy === 'name' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                                [ngClass]="{'text-white': orderBy === 'name'}"></fa-icon>
                        </th>

                        <th scope="col" class="px-10 py-2 font-medium text-nowrap text-sm text-right">
                            Ações
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let template of templates" class="border-b hover:bg-gray-50 cursor-pointer" (click)="edit(template.id)">
                        <td class="p-4 text-sm text-westetics-neutral-950">
                            <div class="flex items-center gap-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30" class="flex-shrink-0 text-westetics-neutral-600">
                                    <path fill="currentColor" d="M6 2C4.895 2 4 2.895 4 4V26C4 27.105 4.895 28 6 28H24C25.105 28 26 27.105 26 26V10.414C26 10.016 25.842 9.634 25.561 9.354L18.646 2.439C18.366 2.158 17.984 2 17.586 2H6zM6 4H17V10C17 11.105 17.895 12 19 12H25V26C25 26.553 24.553 27 24 27H6C5.447 27 5 26.553 5 26V4C5 3.447 5.447 3 6 3zM18 3.414L24.586 10H19C18.447 10 18 9.553 18 9V3.414z"></path>
                                </svg>
                                <span>{{ template.name }}</span>
                            </div>
                        </td>
                        <td class="p-2 text-sm text-westetics-neutral-950">
                            <div class="flex gap-3 justify-end">
                                <button
                                    (click)="edit(template.id); $event.stopPropagation()"
                                    class="p-2 text-westetics-purple-800 hover:text-westetics-purple-600 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                                    title="Editar"
                                >
                                    <fa-icon [icon]="faPenToSquare" class="w-5 h-5"></fa-icon>
                                </button>
                                <button
                                    (click)="downloadTemplate(template); $event.stopPropagation()"
                                    class="p-2 text-westetics-purple-800 hover:text-westetics-purple-600 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                                    title="Download"
                                >
                                    <fa-icon [icon]="faDownload" class="w-5 h-5"></fa-icon>
                                </button>
                                <button
                                    (click)="showDeleteModal(template.id); $event.stopPropagation()"
                                    class="p-2 text-westetics-purple-800 hover:text-westetics-purple-600 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                                    title="Excluir"
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.8 8.4H19.2V20.1C19.2 20.3387 19.1052 20.5676 18.9364 20.7364C18.7676 20.9052 18.5387 21 18.3 21H5.7C5.46131 21 5.23239 20.9052 5.0636 20.7364C4.89482 20.5676 4.8 20.3387 4.8 20.1V8.4ZM6.6 10.2V19.2H17.4V10.2H6.6ZM9.3 12H11.1V17.4H9.3V12ZM12.9 12H14.7V17.4H12.9V12ZM7.5 5.7V3.9C7.5 3.66131 7.59482 3.43239 7.7636 3.2636C7.93239 3.09482 8.1613 3 8.4 3H15.6C15.8387 3 16.0676 3.09482 16.2364 3.2636C16.4052 3.43239 16.5 3.66131 16.5 3.9V5.7H21V7.5H3V5.7H7.5ZM9.3 4.8V5.7H14.7V4.8H9.3Z" fill="currentColor" />
                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- CARDS MOBILE/TABLET -->
        <div class="md:hidden space-y-3 mb-6">
            <div *ngFor="let template of templates" 
                 class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
                 (click)="edit(template.id)">
                <div class="flex justify-between items-start">
                    <div class="flex items-center gap-3 min-w-0 flex-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30" class="flex-shrink-0 text-westetics-neutral-600">
                            <path fill="currentColor" d="M6 2C4.895 2 4 2.895 4 4V26C4 27.105 4.895 28 6 28H24C25.105 28 26 27.105 26 26V10.414C26 10.016 25.842 9.634 25.561 9.354L18.646 2.439C18.366 2.158 17.984 2 17.586 2H6zM6 4H17V10C17 11.105 17.895 12 19 12H25V26C25 26.553 24.553 27 24 27H6C5.447 27 5 26.553 5 26V4C5 3.447 5.447 3 6 3zM18 3.414L24.586 10H19C18.447 10 18 9.553 18 9V3.414z"></path>
                        </svg>
                        <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ template.name }}</h3>
                    </div>
                    <div class="flex gap-2 ml-2">
                        <button
                            (click)="edit(template.id); $event.stopPropagation()"
                            class="p-2 text-westetics-neutral-600 hover:text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                            title="Editar"
                        >
                            <fa-icon [icon]="faPenToSquare" style="width:18px;height:18px"></fa-icon>
                        </button>
                        <button
                            (click)="downloadTemplate(template); $event.stopPropagation()"
                            class="p-2 text-westetics-neutral-600 hover:text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                            title="Download"
                        >
                            <fa-icon [icon]="faDownload" style="width:18px;height:18px"></fa-icon>
                        </button>
                        <button
                            (click)="showDeleteModal(template.id); $event.stopPropagation()"
                            class="p-2 text-westetics-neutral-600 hover:text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                            title="Excluir"
                        >
                            <fa-icon [icon]="faDelete" style="width:18px;height:18px"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mensagem quando não há registros (busca sem resultados) -->
        <div *ngIf="templates.length === 0 && searchTerm" class="text-center py-8 text-westetics-neutral-600">
            Nenhum template encontrado para "{{ searchTerm }}".
        </div>

        <!-- PAGINADOR -->
        <div *ngIf="templates.length > 0 && total_pages > 1" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
            <!-- Info de resultados -->
            <div class="text-xs lg:text-sm text-gray-600 order-3 lg:order-1">
                Mostrando {{ (current_page * pageSize) + 1 }} - {{ Math.min((current_page + 1) * pageSize, total_elements) }} de {{ total_elements }} templates
            </div>
            
            <!-- Controles de paginação -->
            <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
                <!-- Botão Anterior -->
                <button (click)="previous()" 
                        [disabled]="current_page === 0"
                        [ngClass]="{'opacity-50 cursor-not-allowed': current_page === 0}"
                        class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                    </svg>
                </button>
                
                <!-- Números das páginas -->
                <div class="flex items-center gap-1">
                    <button *ngFor="let page of generatePagination(current_page + 1, total_pages)"
                            (click)="navigateTo(page)"
                            [disabled]="page === '...'"
                            [ngClass]="{
                                'bg-westetics-purple-600 text-white': page === current_page + 1,
                                'hover:bg-gray-50': page !== current_page + 1 && page !== '...',
                                'cursor-default': page === '...'
                            }"
                            class="min-w-[32px] lg:min-w-[36px] px-2 lg:px-3 py-1.5 lg:py-2 border border-gray-300 rounded-md transition-colors text-xs lg:text-sm">
                        {{ page }}
                    </button>
                </div>
                
                <!-- Botão Próximo -->
                <button (click)="next()" 
                        [disabled]="current_page + 1 >= total_pages"
                        [ngClass]="{'opacity-50 cursor-not-allowed': current_page + 1 >= total_pages}"
                        class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                </button>
            </div>

            <!-- Seletor de itens por página -->
            <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
                <span class="text-gray-600">Por página:</span>
                <select (change)="changePageSize($event)" [value]="pageSize"
                        class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </select>
            </div>
        </div>

    </ng-container>
</div>

<!-- Modal de Confirmação de Exclusão -->
<div *ngIf="showConfirmDeletePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[400px] shadow-lg">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-base sm:text-lg text-westetics-neutral-950">Confirmar Exclusão</h2>
            <button (click)="closeDeleteModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-xs sm:text-sm text-westetics-neutral-800 mb-4 sm:mb-6">
            Tem certeza que deseja excluir este template? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-2 sm:gap-3">
            <button
                (click)="closeDeleteModal()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-westetics-purple-800 rounded-lg hover:bg-westetics-purple-800 border border-westetics-purple-800 hover:text-white"
            >
                Cancelar
            </button>
            <button
                (click)="onDelete()"
                class="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-300"
            >
                Excluir
            </button>
        </div>
    </div>
</div>

